<template>
    <footer>
        <div class="footer-container wrapper d-flex flex-column">
            <span class="phrase">Polpo es un estudio de arquitectura y diseño con origen en <br> Buenos Aires abocado a la experimentación y guiado por la curiosidad.</span>
            <div class="w-100 d-flex justify-content-between">
                <a href="mailto:info@polpo.com.ar" class="contact">CONTACTENOS</a>
            </div>
        </div>
        <a class="instagram" href="https://www.instagram.com/estudiopolpo/" target="_blank"><InstagramAnimation></InstagramAnimation></a>
        <div class="copyrights-container wrapper d-flex flex-column">
            <span class="copyrights">2020 Polpo® Todos los derechos reservados <br>Buenos Aires Argentina</span>
        </div>
    </footer>
</template>

<script>
import InstagramAnimation from '@/components/InstagramAnimation'
export default {
  name: 'Footer',
  components: {
    InstagramAnimation
  }
}
</script>

<style lang="scss">
@import '../assets/scss/vars';
footer{
    margin-bottom: 3rem;
    position: relative;
    .footer-container{
        border-bottom: 1px solid $dark-gray;
        padding: 2rem 0px;
        margin-bottom: 2rem;
        .phrase{
            margin-bottom: 30px;
            font-size: 30px;
            line-height: 120%;
            font-weight: 200;
        }
        .contact{
            margin-top: 10px;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 5px;
        }
    }
    .instagram{
        padding-left: 8px;
        width: 80px;
        position: absolute;
        right: 40px;
        bottom: 120px;
        transform: scale(1.5);
        // &.below-viewport{
        //     opacity: 0;
        // }
        // &.in-viewport{
        //     animation: fadeInUp .8s ease-in-out forwards;
        // }
    }
}

@keyframes fadeInUp{
    0% {bottom: 0px; opacity: 0;}
    50% {opacity: 0;}
    100% {opacity: 1;}
}

@media screen and (max-width: 600px){
    footer{
        margin-bottom: 0;
        .footer-container{
            .phrase{
                font-size: 20px;
            }
            .contact{
                font-size: 14px;
            }
        }
        .instagram{
            right: 0px;
            bottom: 94px;
            transform: scale(1.25);
        }
        .copyrights{
            font-size: 10px;
        }
    }
}
</style>
